/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */
/* eslint-disable global-require */

import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { useStaticQuery, graphql } from 'gatsby';
import Facebook from './Facebook';
import Twitter from './Twitter';

function SEO({ title, desc, banner, pathname, article, node, socialImage }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          buildTime
          siteMetadata {
            siteUrl
            defaultTitle: title
            defaultDescription: description
            defaultBanner: banner
            headline
            siteLanguage
            ogLanguage
            author
            twitter
            facebook
          }
        }
      }
    `,
  );

  const {
    buildTime,
    siteMetadata: {
      siteUrl,
      defaultTitle,
      defaultDescription,
      defaultBanner,
      headline,
      siteLanguage,
      ogLanguage,
      author,
      orgAuthor,
      legalName,
      twitter,
      facebook,
    },
  } = site;

  const seo = {
    title: title || defaultTitle,
    description: desc || defaultDescription,
    image: `${siteUrl}${banner || defaultBanner}`,
    url: `${siteUrl}${pathname || ''}`,
  };

  const schemaOrgWebPage = {
    '@context': 'http://schema.org',
    '@type': 'WebPage',
    url: siteUrl,
    headline,
    inLanguage: siteLanguage,
    mainEntityOfPage: siteUrl,
    description: defaultDescription,
    name: defaultTitle,
    author: {
      '@type': 'Organization',
      name: orgAuthor,
      legalName,
    },
    copyrightHolder: {
      '@type': 'Organization',
      name: orgAuthor,
      legalName,
    },
    copyrightYear: '2019',
    creator: {
      '@type': 'Organization',
      name: orgAuthor,
      legalName,
    },
    publisher: {
      '@type': 'Organization',
      name: orgAuthor,
      legalName,
    },
    datePublished: '2019-01-18T10:30:00+01:00',
    dateModified: buildTime,
    image: {
      '@type': 'ImageObject',
      url: `${siteUrl}${defaultBanner}`,
    },
  };

  // Initial breadcrumb list

  const itemListElement = [
    {
      '@type': 'ListItem',
      item: {
        '@id': siteUrl,
        name: 'Homepage',
      },
      position: 1,
    },
  ];

  let schemaArticle = null;

  schemaArticle = {
    '@context': 'http://schema.org',
    '@type': 'Article',
    author: {
      '@type': 'Person',
      name: author,
    },
    copyrightHolder: {
      '@type': 'Person',
      name: author,
    },
    copyrightYear: '2019',
    creator: {
      '@type': 'Person',
      name: author,
    },
    publisher: {
      '@type': 'Organization',
      name: author,
      logo: {
        '@type': 'ImageObject',
        url: `${siteUrl}${defaultBanner}`,
      },
    },
    // datePublished: node.first_publication_date,
    // dateModified: node.last_publication_date,
    description: seo.description,
    headline: seo.title,
    inLanguage: siteLanguage,
    url: seo.url,
    name: seo.title,
    image: {
      '@type': 'ImageObject',
      url: seo.image,
    },
    mainEntityOfPage: seo.url,
  };
  // Push current blogpost into breadcrumb list
  itemListElement.push({
    '@type': 'ListItem',
    item: {
      '@id': seo.url,
      name: seo.title,
    },
    position: 2,
  });

  const breadcrumb = {
    '@context': 'http://schema.org',
    '@type': 'BreadcrumbList',
    description: 'Breadcrumbs list',
    name: 'Breadcrumbs',
    itemListElement,
  };

  const metaDescription = desc || site.siteMetadata.description;
  const canonical = pathname ? `${site.siteMetadata.siteUrl}${pathname}` : null;

  return (
    <>
      <Helmet
        title={title}
        titleTemplate="%s | ShopFeedback"
        link={
          canonical
            ? [
                {
                  rel: 'canonical',
                  href: canonical,
                },
              ]
            : []
        }
      >
        <html lang={siteLanguage} />
        <meta name="description" content={seo.description} />
        <meta name="image" content={seo.image} />
        <link
          href="https://fonts.googleapis.com/css2?family=Poppins:wght@400;600;700&display=swap"
          rel="stylesheet"
        />
        <meta
          name="keywords"
          content="nps surveys for shopify, customer survey shopify, customer.guru, ShopFeedback, retently, delighted"
        />
        <meta
          name="google-site-verification"
          content="QOizFxNOmClTKztGa9Au136wVIK6iZPbyvFzBHitBVw"
        />
        {/* Insert schema.org data conditionally (webpage/article) + everytime (breadcrumbs) */}
        <script type="application/ld+json">
          {JSON.stringify(schemaOrgWebPage)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(schemaArticle)}
        </script>
        <script type="application/ld+json">{JSON.stringify(breadcrumb)}</script>
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href={require('../../apple-touch-icon.png')}
        />
        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href={require('../../favicon-32x32.png')}
        />
        <link
          rel="icon"
          type="image/png"
          sizes="16x16"
          href={require('../../favicon-16x16.png')}
        />
        <link rel="icon" href={require('../../favicon.ico')} />
        <script type="text/javascript">
          {`
            !(function(e, t, n) {
              function a() {
                let e = t.getElementsByTagName('script')[0],
                  n = t.createElement('script');
                (n.type = 'text/javascript'),
                  (n.async = !0),
                  (n.src = 'https://beacon-v2.helpscout.net'),
                  e.parentNode.insertBefore(n, e);
              }
              if (
                ((e.Beacon = n = function(t, n, a) {
                  e.Beacon.readyQueue.push({ method: t, options: n, data: a });
                }),
                (n.readyQueue = []),
                'complete' === t.readyState)
              )
                return a();
              e.attachEvent
                ? e.attachEvent('onload', a)
                : e.addEventListener('load', a, !1);
            })(window, document, window.Beacon || function() {})
          `}
        </script>
        <script type="text/javascript">
          window.Beacon('init', '2a603266-46e0-466a-bd21-a987adfc6324')
        </script>
      </Helmet>
      <Facebook
        desc={seo.description}
        image={socialImage || seo.image}
        title={seo.title}
        type="website"
        url={seo.url}
        locale={ogLanguage}
      />
      <Twitter
        title={seo.title}
        image={socialImage || seo.image}
        desc={seo.description}
        username={twitter}
      />
    </>
  );
}

SEO.propTypes = {
  title: PropTypes.string,
  desc: PropTypes.string,
  banner: PropTypes.string,
  pathname: PropTypes.string,
  article: PropTypes.bool,
  node: PropTypes.object,
};

SEO.defaultProps = {
  title: null,
  desc: null,
  banner: null,
  pathname: null,
  article: false,
  node: null,
};

export default SEO;
